// extracted by mini-css-extract-plugin
module.exports = {"popularPosts":"styles-module--popular-posts--33QEy"};